import { Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Footer from './footer/footer.component';
import Header from './header/header.component';

const PageLayout = () => {
    return (
        <Stack direction={'column'} justifyContent={'space-between'} style={{ minHeight: '100vh' }}>
            <Header />
            <div style={{ margin: '10px', flexGrow: 1 }}>
                <Outlet />
            </div>
            <Footer />
        </Stack>
    );
};

export default PageLayout;
